import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ProductsReviewsService } from 'src/app/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {Router, Event, NavigationEnd, ActivatedRoute, RoutesRecognized} from '@angular/router';
import { NzNotificationService, NzModalService } from 'ng-zorro-antd';
import { removeEmptyQuery, sleep } from 'src/app/helpers';
import {ProductReviewDto} from "./DTO/product-review.dto";
import {Criteria} from "./DTO/product-overview.dto";
import moment from "moment";

@Component({
  selector: 'app-products-reviews',
  templateUrl: './products-reviews.component.html',
  styleUrls: ['./products-reviews.component.scss'],
})
export class ProductsReviewsComponent implements OnInit, OnDestroy {

  constructor(
    private reviewService: ProductsReviewsService,
    private notification: NzNotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.router.events
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          this.productId = window.location.href.split('/')[5];
          console.log('this.productId', this.productId);
          this.average_point_from = null;
          this.average_point_to = null;
          // this.loadCriteria();
          this.loadData2();
        }
      });
  }
  unsubscribe$ = new Subject<void>();

  pageIndex = 1;
  pageSize = 10;
  productReview: ProductReviewDto;
  rows
  filters = [
    { filter: '<6 Trung bình', value: 0 },
    { filter: '6-7 Trung bình', value: 1 },
    { filter: '7-8 Tốt', value: 2 },
    { filter: '8-9 Tuyệt vời', value: 3 },
    { filter: '>9 Trên cả tuyệt vời', value: 4 },
  ];

  sorts = [
    { sort: 'Mới nhất', value: 0 },
    { sort: 'Cũ nhất', value: 0 },
  ];

  average_point_from: number;
  average_point_to: number;

  productId: string;

  // ================================list==================================//
  listOfAllData: any[] = [];
  total = 0;
  loading: Boolean = true;
  hasMore: any;
  hasCollapse: any;

  criterias: Criteria[];
  rating= 0

  average_point: number;
  product_evaluation_gather: any = [];

  openMessage(type: string, title: string, content: any) {
    return this.notification.create(type, title, content);
  }
  filterReview(data: any) {
    this.pageIndex = 1;
    if (data === 0) {
      this.average_point_from = 0;
      this.average_point_to = 2.99;
      this.loadData();
      return;
    } else if (data === 1) {
      this.average_point_from = 3;
      this.average_point_to = 3.49;
      this.loadData();
      return;
    } else if (data === 2) {
      this.average_point_from = 3.5;
      this.average_point_to = 3.99;
      this.loadData();
      return;
    } else if (data === 3) {
      this.average_point_from = 4;
      this.average_point_to = 4.49;
      this.loadData();
      return;
    } else if (data === 4) {
      this.average_point_from = 4.5;
      this.average_point_to = 5;
      this.loadData();
      return;
    }
  }
  ngOnInit() {

    this.router.events.subscribe((data) => {
      if (data instanceof RoutesRecognized) {
        const routeData = data.state.root.firstChild.data;
      }
    });
    this.productId = window.location.href.split('/')[5];

    this.average_point_from = null;
    this.average_point_to = null;
    // this.loadData();
    this.loadCriteria();

    this.reviewService.currentStatus
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((status) => {

        if (status) {
          this.pageIndex = 1;
          this.loadData();
          return;
        } else {
          this.loadData();
        }
      }, error => console.log(error));
  }

  sleep(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async loadData(ms = 0) {
    const query: any = {
      product_id: this.productId,
      average_point_from: this.average_point_from
        ? this.average_point_from
        : null,
      average_point_to: this.average_point_to ? this.average_point_to : null,
      offset: (this.pageIndex - 1) * this.pageSize,
      limit: this.pageSize,
    };

    removeEmptyQuery(query);
    await sleep(ms);
    console.log(query)
    this.loading = true;
    this.reviewService
      .getAll(query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.productReview = res;
          console.log('this.productReview', this.productReview)
          this.loading = false;
          this.total = res.count;
          this.listOfAllData = res.rows;

          if (res.rows) {
            if (this.listOfAllData.length === this.total || this.total === 1) {
              this.hasMore = false;
            } else {
              this.hasMore = true;
            }

            if (this.listOfAllData.length <= 1) {
              this.hasCollapse = false;
            } else {
              this.hasCollapse = true;
            }
          }
        },
        (err) => {
          this.openMessage('error', 'Lỗi !!!', `${err}`);
          return;
        }
      );
  }

  async loadData2(ms = 0) {
    const query: any = {
      product_id: this.productId,
      average_point_from: this.average_point_from
        ? this.average_point_from
        : null,
      average_point_to: this.average_point_to ? this.average_point_to : null,
      offset: (this.pageIndex - 1) * this.pageSize,
      limit: this.pageSize,
    };

    removeEmptyQuery(query);
    await sleep(ms);

    this.loading = true;
    this.reviewService
      .getAll(query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.productReview = res;
          this.rows= res.rows.map(z => {
            return {...z, created_at1: moment(z.created_at).format('x')};
          }).sort((a,b) => b.created_at1 - a.created_at1);
          console.log('rows', this.rows)
          this.loading = false;
          this.total = res.count;
          const arr = this.productReview.rows;
          if (res.rows) {
            if (arr.length === this.total || this.total === 1) {
              this.hasMore = false;
            } else {
              this.hasMore = true;
            }

            if (arr.length <= 1) {
              this.hasCollapse = false;
            } else {
              this.hasCollapse = true;
            }
          }

          if (res.code === 1008) {
            this.openMessage('warning', 'Cảnh báo', `${res.message}`);
          }
        },
        (err) => {
          // this.openMessage('error', 'Lỗi !!!', `${err}`);
          return;
        }
      );
  }

  loadMore(type: string) {
    if (type === 'more') {
      this.pageSize = this.pageSize + 10;
      this.loadData();
      return;
    }
    if (type === 'collapse') {
      this.pageSize = this.pageSize - 10;
      if (this.pageSize < 1) {
        this.pageSize = 1;
      }
      this.loadData();
      return;
    }
  }
  loadCriteria() {
    const query: any = {
      product_id: this.productId,
      offset: (this.pageIndex - 1) * this.pageSize,
      limit: this.pageSize,
    };

    removeEmptyQuery(query);

    this.reviewService
      .getAllCriteria(query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          console.log(123 , res)
          this.criterias = res.criteriaList;
          this.rating = res.rating / 2;
        },
        (err) => {
          this.openMessage('error', 'Lỗi !!!', `${err}`);
          return;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
